define('enquire-patched',[
	"media-match",
	"feature!enquire"
], function(
	undefined1,
	enquire
) {
	return enquire;
});
